import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import './TrapAlertHistory.css';

const TrapAlertHistory = () => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await fetch(`${config.TRAP_API_BASE_URL}/api/alerts/history`);
        if (response.ok) setAlerts(await response.json());
      } catch (error) {
        console.error('Error fetching trap alert history:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
    const interval = setInterval(fetchHistory, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className="trap-history-page">
      <header className="trap-history-header">
        <button className="back-button" onClick={() => navigate(-1)} aria-label="Go back">{'<'}</button>
        <div>
          <h1>Trap Alert History</h1>
          <p>Bedbug and rodent events - retained for four months</p>
        </div>
      </header>

      {loading ? (
        <p className="trap-history-empty">Loading alert history...</p>
      ) : alerts.length === 0 ? (
        <p className="trap-history-empty">No acknowledged trap alerts yet.</p>
      ) : (
        <section className="trap-history-list" aria-label="Past trap alerts">
          {alerts.map(alert => (
            <article className="trap-history-row" key={alert.id}>
              <div className="trap-history-event">
                <strong>{alert.event_type}</strong>
                <span>{alert.device_id} | {alert.unit_type === 'versa_rodent' ? 'Rodent' : 'Bedbug'}</span>
                <span>{alert.ship_name} | {alert.location_section} | {alert.area_cabin}</span>
              </div>
              <dl>
                <div><dt>Alerted</dt><dd>{new Date(alert.triggered_at).toLocaleString()}</dd></div>
                <div><dt>Acknowledged</dt><dd>{new Date(alert.acknowledged_at).toLocaleString()}</dd></div>
              </dl>
            </article>
          ))}
        </section>
      )}
    </main>
  );
};

export default TrapAlertHistory;